export default {
  __name: 'index',
  props: {
  poster: {
    type: String,
    required: false,
  },
  src: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

}